/* Eyeshells - Collection grid columns persistence (2–5) 
   Keeps user's choice across pagination / AJAX filter updates.
   Storage: localStorage (fallback: sessionStorage). */

(function () {
  var KEY = 'es_cols_per_row';
  var APPLYING = false;

  function getStore() {
    try {
      var ls = window.localStorage;
      var x = '__es_test__';
      ls.setItem(x, '1');
      ls.removeItem(x);
      return ls;
    } catch (e) {
      try { return window.sessionStorage; } catch (e2) { return null; }
    }
  }

  function clampCols(v) {
    v = parseInt(v, 10);
    if (v >= 2 && v <= 5) return v;
    return null;
  }

  function normalizeCols(cols) {
    cols = clampCols(cols);
    if (!cols) return null;

    var w = window.innerWidth || document.documentElement.clientWidth || 0;

    // Mobile: force 2 columns (theme hides other buttons anyway)
    if (w && w < 768) return 2;

    // Tablet-ish: 5 columns isn't supported well in this theme; degrade to 4
    if (w && w < 1300 && cols === 5) return 4;

    return cols;
  }

  function setHtmlColsClass(cols) {
    try {
      var el = document.documentElement;
      el.classList.remove('es-cols-2', 'es-cols-3', 'es-cols-4', 'es-cols-5');
      if (cols) el.classList.add('es-cols-' + cols);
    } catch (e) {}
  }

  function triggerThemeButton(cols) {
    // Prefer using theme's own handlers (keeps all classes/active states consistent).
    var sel = '.prod_per a.size_' + cols;
    var btn = document.querySelector(sel);
    if (!btn) return false;

    // If jQuery exists, trigger via jQuery to ensure delegated handlers fire.
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.trigger) {
      APPLYING = true;
      try { window.jQuery(sel).trigger('click'); } catch (e) {}
      APPLYING = false;
      return true;
    }

    // Vanilla fallback
    APPLYING = true;
    try { btn.dispatchEvent(new MouseEvent('click', { bubbles: true })); } catch (e) {}
    APPLYING = false;
    return true;
  }

  function apply(cols) {
    cols = normalizeCols(cols);
    if (!cols) return;

    setHtmlColsClass(cols);

    // Let the theme apply the grid classes.
    // If not available (rare), fallback to direct class edits.
    if (triggerThemeButton(cols)) return;

    // Fallback: apply bootstrap-like sizing directly.
    try {
      var items = document.querySelectorAll('.template-collection .product-grid-view .js_size_prod');
      if (!items || !items.length) return;

      items.forEach(function (it) {
        it.classList.remove(
          'col-lg-1','col-lg-2','col-lg-3','col-lg-4','col-lg-5','col-lg-6','col-lg-7','col-lg-8','col-lg-9','col-lg-10','col-lg-11','col-lg-12','col-lg-2dot4',
          'col-md-1','col-md-2','col-md-3','col-md-4','col-md-5','col-md-6','col-md-7','col-md-8','col-md-9','col-md-10','col-md-11','col-md-12',
          'col-12','col-6'
        );
        if (cols === 2) it.classList.add('col-6');
        if (cols === 3) it.classList.add('col-md-4');
        if (cols === 4) it.classList.add('col-md-3');
        if (cols === 5) it.classList.add('col-lg-2dot4');
      });

      var buttons = document.querySelectorAll('.template-collection .prod_per a');
      buttons.forEach(function (b) { b.classList.remove('active'); });
      var act = document.querySelector('.template-collection .prod_per a.size_' + cols);
      if (act) act.classList.add('active');
    } catch (e) {}
  }

  function read() {
    var store = getStore();
    if (!store) return null;
    return clampCols(store.getItem(KEY));
  }

  function write(cols) {
    var store = getStore();
    if (!store) return;
    store.setItem(KEY, String(cols));
  }

  // Public hook so AJAX filtering can re-apply after replacing the grid
  window.ES_applyCollectionCols = function () {
    apply(read());
  };

  // Apply on first paint (after theme init)
  document.addEventListener('DOMContentLoaded', function () {
    apply(read());
  });

  // Persist when user changes
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('.prod_per a') : null;
    if (!a) return;

    var m = (a.className || '').match(/\bsize_(2|3|4|5)\b/);
    if (!m) return;

    var cols = clampCols(m[1]);
    cols = normalizeCols(cols) || cols;

    if (!APPLYING) {
      write(cols);
      setHtmlColsClass(cols);
    }
  });

  // If theme's resize logic overwrites the user's choice, re-apply shortly after resize settles
  var resizeT = null;
  window.addEventListener('resize', function () {
    if (resizeT) clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      apply(read());
    }, 150);
  }, { passive: true });

})();
